import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import type {OpenableModal} from './openable-modals';
// @ts-expect-error
import {ActionTypes, OpenableModalsAction} from './openable-modals-actions';

export type OpenableModalsState = {
    openModals: OpenableModal[];
};

export const defaultOpenableModalsState: OpenableModalsState = {
    openModals: [],
};

export const openableModalsReducer = (
    state: OpenableModalsState | null | undefined = defaultOpenableModalsState,
    action: OpenableModalsAction
): OpenableModalsState => {
    switch (action.type) {
        case ActionTypes.MODAL_OPENED:
            return {
                // @ts-expect-error
                openModals: [...state.openModals, {id: action.id, options: action.options}],
            };
        case ActionTypes.MODAL_CLOSED:
            return {
                // @ts-expect-error
                openModals: state.openModals.filter(
                    (openModal: OpenableModal) => openModal.id !== action.id
                ),
            };
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            return state;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
